export default "__VITE_ASSET__Bmar2ybH__"